export const getIriFromId = (ModelConstructor: any, id: id) => {
  const model = new ModelConstructor({ id });
  const uri = model.path;
  return uri;
};

export const getIdFromIri = (ModelConstructor: any, iri: string) => {
  const modelPath = ModelConstructor.path;
  const pattern = /(.+){.+}/;
  const found = modelPath.match(pattern);

  if (found[1]) {
    if (iri.indexOf(found[1]) === -1) {
      console.warn('Wrong ModelConstructor in getIdFromIri');
      return null;
    }

    return iri.replace(found[1], '');
  }

  return null;
};
